var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99805 1.125L9.76868 5.31072C9.8367 5.47148 9.94378 5.61056 10.0792 5.714C10.2146 5.81744 10.3735 5.88152 10.5399 5.89986L14.873 6.37702L11.6342 9.44113C11.5098 9.55882 11.4171 9.70888 11.3653 9.87623C11.3137 10.0436 11.3048 10.2223 11.3396 10.3944L12.247 14.875L8.47467 12.583C8.32977 12.495 8.1654 12.4486 7.99805 12.4486C7.83069 12.4486 7.66633 12.495 7.52143 12.583L3.74906 14.875L4.65648 10.3944C4.69134 10.2223 4.68244 10.0436 4.63075 9.87623C4.57902 9.70888 4.4863 9.55882 4.3619 9.44113L1.12305 6.37702L5.45621 5.89986C5.62263 5.88152 5.78154 5.81744 5.91693 5.714C6.05231 5.61056 6.1594 5.47148 6.22741 5.31072L7.99805 1.125Z",
    fill: "#E5D500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7f613fe8798d226498f7b4fcb53b694f.svg";
export { ForwardRef as ReactComponent };